module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/glyphicons-halflings-regular.ttf
// module id = ./node_modules/@ps/common-core/dist/fonts/glyphicons-halflings-regular.ttf
// module chunks = 1